<template>
  <v-card outlined class="fill-height">
    <v-list-item :to="to" class="fill-height" @click="openAction">
      <v-list-item-avatar v-if="icon" tile size="50" :color="color">
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-if="title" class="font-weight-bold primary--text">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="description" class="text-wrap">
          {{ description }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-chip v-if="badge" :color="color" class="ml-2">{{ badge }}</v-chip>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'AdministrationOverviewItem',

  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    badge: {
      type: [String, Number],
      required: false,
      default: null
    },
    to: {
      type: Object,
      required: false,
      default: null
    }
  },

  computed: {
    color() {
      return this.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'
    }
  },

  methods: {
    openAction() {
      this.$emit('submit:action')
    }
  }
}
</script>
